import { render, staticRenderFns } from "./kamiCode.vue?vue&type=template&id=7503b2e0&scoped=true&"
import script from "./kamiCode.vue?vue&type=script&lang=js&"
export * from "./kamiCode.vue?vue&type=script&lang=js&"
import style0 from "./kamiCode.vue?vue&type=style&index=0&id=7503b2e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7503b2e0",
  null
  
)

export default component.exports